export const PAGE_VIEW = 'page_view'
export const SELECT_PROMOTION = 'select_promotion'
